
import { mapGetters, mapActions } from "vuex";
import formValidation from "@/mixins/formValidation";
import detectBot from "@/mixins/detectBot";
import checkboxManagerMixin from "~/mixins/checkboxManager";

export default {
  mixins: [formValidation, detectBot, checkboxManagerMixin],
  props: {
    offer: Object
  },
  data() {
    return {
      isSpam: {
        // phone: true,
        name: true
      },
      hasClientPhone: false
    };
  },
  computed: {
    ...mapGetters({
      settings: "settings/settings/settings"
    }),
    isSpammed() {
      return Object.values(this.isSpam).find(val => val === true);
    }
  },
  methods: {
    handleSpam(isSpam, key) {
      this.isSpam[key] = isSpam;
    },
    ...mapActions({
      sendForm: "form/form/sendForm",
      closeModal: "modal/modal-receipt-vin/closeModal",
      openModalAutoteka: "modal/modal-main/openModal"
    }),
    checkForm() {
      if (!this.form.phone.valid) {
        this.form.phone.valid = false;
        return false;
      }
      if (!this.validateCheckboxes()) {
        return false;
      }
      return true;
    },
    setUtmToFormData(formData) {
      if (localStorage.utm_source) {
        formData.utm_source = localStorage.utm_source;
      }
      if (localStorage.utm_medium) {
        formData.utm_medium = localStorage.utm_medium;
      }
      if (localStorage.utm_campaign) {
        formData.utm_campaign = localStorage.utm_campaign;
      }
      if (localStorage.utm_term) {
        formData.utm_term = localStorage.utm_term;
      }
      if (localStorage.utm_content) {
        formData.utm_content = localStorage.utm_content;
      }
    },
    async submitForm() {
      if (!this.checkForm()) return;

      let formData = {
        chosen_car: this.offer,
        type: "autoteka",
        client_phone: this.form.phone.value,
        comment: null
      };

      this.setUtmToFormData(formData);

      if (this.offer) {
        formData.external_id = this.offer.external_id;
      }

      await this.sendForm(formData);
      localStorage.setItem("client_phone", formData.client_phone);
      this.hasClientPhone = formData.client_phone;

      let payload = {
        modal_data: this.offer,
        modal_component: "modal-autoteka",
        modal_title: "Отчет по акутальным базам РФ от " + this.offer.createdAt,
        modal_sub_title: this.offer.name
      };
      await this.openModalAutoteka(payload);
      this.closeModal()
    }
  },
  mounted() {
    this.hasClientPhone = localStorage.getItem("client_phone") || "";
  }
};
